// NOTE: originally Lovable-generated; edited to lazy-load the Supabase client so the
// ~150KB (gz) @supabase/supabase-js SDK no longer ships in the eager client entry.
// It is imported on demand only when a serverFn RPC actually runs.
import { createMiddleware } from "@tanstack/react-start";

// Must be registered as a global `functionMiddleware` in `src/start.ts`; otherwise
// the browser never attaches the bearer token to serverFn RPCs.
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    // SSR guard: token chỉ tồn tại trong localStorage của browser. Import
    // supabase-js trong SSR còn crash trên Node 20 (thiếu WebSocket native).
    if (typeof window === "undefined") return next();
    const { supabase } = await import("./client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
